module.exports = __webpack_public_path__ + "static/media/gallery-29.7662131e.jpg";